import { Cancel, Search } from "@mui/icons-material";
import {
  Box,
  Checkbox,
  FormControl,
  IconButton,
  InputAdornment,
  InputLabel,
  OutlinedInput,
  Paper,
  Tab,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  Tabs,
  Drawer,
  Divider,
} from "@mui/material";
import "./Maintenance.css";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import axios from "axios";
import { ChevronDown, ChevronRight, ChevronUp, EyeOff } from "lucide-react";
import client from "../../assets/images/client-image.png";
import NotFound from "../SharedModule/NotFound";
import RequestProfile from "./RequestProfile";
import { toast } from "react-toastify";
import DatePickerDMY from "../DatePickerDMY";
import { formatNumber } from "../../hooks/formatNumber";
import { useParams } from "react-router";
import { database } from "../../firebase";
import { ref, query, limitToLast, onChildAdded } from "firebase/database";

export default function Maintenance() {

  const { user } = useSelector((state) => state.auth);
  const token = user?.token;
  const newBaseUrl = "https://estbn.com/EstbnNew/public";
  const headers = { Authorization: "Bearer " + token };
  const { id } = useParams();

  /* ===================== Bundles ===================== */

  const [openBundleId, setOpenBundleId] = useState(null);

  const toggleBundle = (id) => {
    setOpenBundleId((prev) => (prev === id ? null : id));
  };

  const [selectedBundles, setSelectedBundles] = useState([]);

  const [bundleData, setBundleData] = useState({});

  const [openDetails, setOpenDetails] = useState(false);

  const handleToggleBundleSelect = (id, name) => {
    setSelectedBundles((prev) => {
      if (prev.includes(id)) {
        const updated = prev.filter((b) => b !== id);

        setBundleData((old) => {
          const copy = { ...old };
          delete copy[id];
          return copy;
        });

        return updated;
      } else {
        const servicesData = {};

        services.forEach((srv) => {
          servicesData[srv.service.id] = {
            servicePrice: srv.service.price,
            productPrice: 0,
            productId: null,
          };
        });

        setBundleData((old) => ({
          ...old,
          [id]: {
            services: servicesData,
          },
        }));

        return [...prev, id];
      }
    });
  };

  /* ===================== Drawer & Helpers ===================== */

  const [expiryDate, setExpiryDate] = useState("");
  const [displayDate, setDisplayDate] = useState("");

  const formatToDisplay = (isoDate) => {
    if (!isoDate) return "";
    const [yyyy, mm, dd] = isoDate.split("-");
    return `${dd}/${mm}/${yyyy}`;
  };

  /* ===================== Statuses & Orders ===================== */

  const [total, setTotal] = useState(null);
  const [statuses, setStatuses] = useState([]);
  const [orders, setOrders] = useState([]);
  const [request, setRequest] = useState(null);
  const [services, setServices] = useState([]);
  const [selectedTab, setSelectedTab] = useState("all");
  const [searchQuery, setSearchQuery] = useState("");
  const [filterDate, setFilterDate] = useState("");
  const [selectedRows, setSelectedRows] = useState([]);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [totalCount, setTotalCount] = useState(0);
  const [openSelect, setOpenSelect] = useState(null);

  const getStatuses = async () => {
    try {
      const response = await axios.get(
        `${newBaseUrl}/api/portal/price-plans/requests/status-counts`,
        { headers },
      );
      console.log(response.data.data);
      setTotal(response.data.data.total_requests);
      setStatuses(response.data.data.status_counts);
    } catch (error) {
      console.log(error);
    }
  };

  const getOrders = async () => {
    try {
      const params = {
        page: page + 1,
        per_page: rowsPerPage,
      };

      if (filterDate) params.reservation_date = filterDate;
      if (selectedTab && selectedTab !== "all") params.status = selectedTab;

      const response = await axios.get(
        `${newBaseUrl}/api/portal/price-plans/requests`,
        {
          headers,
          params,
        },
      );
      console.log(response.data.data.requests);
      const data = response.data.data.requests;
      setOrders(data.data || []);
      setTotalCount(data.total);
    } catch (error) {
      console.log(error);
    }
  };

  const getRequest = async (reqId) => {
    try {
      const response = await axios.get(
        `${newBaseUrl}/api/portal/price-plans/requests/${reqId}/analyze`,
        { headers },
      );
      console.log(response.data.data.request_analysis);
      setRequest(response.data.data.request_analysis);
    } catch (error) {
      console.log(error);
    }
  };

  const getServices = async (reqId) => {
    try {
      const response = await axios.get(
        `${newBaseUrl}/api/portal/price-plans/requests/${reqId}/services-products`,
        { headers },
      );
      console.log(response.data.data.services_with_products);
      setServices(response.data.data.services_with_products);
    } catch (error) {
      console.log(error);
    }
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
    console.log(newPage);
  };

  const handleSelectRow = (id) => {
    setSelectedRows((prev) =>
      prev.includes(id) ? prev.filter((r) => r !== id) : [...prev, id],
    );
  };

  const handleSelectAll = (event) => {
    if (event.target.checked) {
      const allIds = orders.map((row) => row.id);
      setSelectedRows(allIds);
    } else {
      setSelectedRows([]);
    }
  };

  const handlOpenDetails = async (row) => {
    setSelectedBundles([]);
    setBundleData({});
    setOpenDetails(true);
    if (row.status?.key === "pending" || row.status?.key === "reviewed") {
      setDrawerMode("edit");
      getRequest(row.id);
      getServices(row.id);
    } else {
      setDrawerMode("profile");
      await getRequestAnalysis(row.id);
    }
  };

  //  pricing function

  const handleProductSelect = (templateId, serviceId, productId, products) => {
    const product = products.find((p) => p.id == productId);
    const service = services.find((s) => s.service.id == serviceId);

    setBundleData((prev) => ({
      ...prev,
      [templateId]: {
        ...prev[templateId],

        services: {
          ...prev[templateId]?.services,

          [serviceId]: {
            productId,

            // سعر المنتج
            productPrice: product?.current_price || 0,

            // سعر الخدمة
            servicePrice: service?.service?.price || 0,
          },
        },
      },
    }));
  };

  const handleSaveDraft = () => {
    const draft = {
      requestId: request?.request_id,
      selectedBundles,
      bundleData,
      expiryDate,
    };

    localStorage.setItem("pricePlanDraft", JSON.stringify(draft));

    alert("Draft Saved ✅");
  };

  const buildFormData = () => {
    const formData = new FormData();

    formData.append("request_id", request.request_id);
    formData.append("expires_at", expiryDate);

    selectedBundles.forEach((templateId, i) => {
      const template = request?.suggested_templates?.find(
        (b) => b.template.id === templateId,
      );
      if (!template) return;
      // template
      formData.append(`offers[${i}][template_id]`, templateId);
      formData.append(`offers[${i}][offer_name]`, template.template.name);

      // optional (لو موجودين من API)
      formData.append(`offers[${i}][discount_percentage]`, 0);
      formData.append(`offers[${i}][is_recommended]`, 0);

      services?.forEach((srv, j) => {
        const saved = bundleData[templateId]?.services?.[srv.service.id] || {};

        // service
        formData.append(
          `offers[${i}][services][${j}][service_id]`,
          srv.service.id,
        );

        formData.append(
          `offers[${i}][services][${j}][service_price]`,
          saved.price || srv.service.price,
        );

        // REQUIRED
        formData.append(`offers[${i}][services][${j}][quantity]`, 1);

        // products
        if (saved.productId) {
          formData.append(
            `offers[${i}][services][${j}][products][0][product_id]`,
            saved.productId,
          );

          // REQUIRED
          formData.append(
            `offers[${i}][services][${j}][products][0][quantity]`,
            1,
          );

          formData.append(
            `offers[${i}][services][${j}][products][0][unit_price]`,
            saved.productPrice,
          );

          // REQUIRED
          formData.append(
            `offers[${i}][services][${j}][products][0][is_required]`,
            1,
          );
        }
      });
    });

    return formData;
  };

  const handleSendBundles = async () => {
    try {
      const formData = buildFormData();
      for (let pair of formData.entries()) {
        console.log(pair[0], pair[1]);
      }

      await axios.post(
        `${newBaseUrl}/api/portal/price-plans/offers/create-multiple-with-services`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      );
      localStorage.removeItem("pricePlanDraft");
      toast.success("Sent Successfully ✅", { autoClose: 3000 });
      setOpenDetails(false);
      setSelectedBundles([]);
      setBundleData({});
      getOrders();
    } catch (err) {
      toast.error(
        "Error While Sending ❌ " + (err.response?.data?.errors?.error || ""),
      );
    }
  };

  const getBundleTotal = (templateId) => {
    const bundle = bundleData[templateId];

    if (!bundle?.services) return 0;

    let total = 0;

    Object.values(bundle.services).forEach((srv) => {
      total += Number(srv.servicePrice || 0);
      total += Number(srv.productPrice || 0);
    });

    return total;
  };

  // request profile

  const [drawerMode, setDrawerMode] = useState(null);
  const [analysisData, setAnalysisData] = useState(null);
  const [loadingAnalysis, setLoadingAnalysis] = useState(false);

  const getRequestAnalysis = async (id) => {
    try {
      setLoadingAnalysis(true);
      const res = await axios.get(
        `${newBaseUrl}/api/portal/price-plans/requests/${id}/analyze`,
        { headers },
      );
      console.log(res.data.data.request_analysis);
      setAnalysisData(res.data.data.request_analysis);
    } catch (err) {
      console.log(err);
    } finally {
      setLoadingAnalysis(false);
    }
  };

  // effects

  useEffect(() => {
    getStatuses();
    getOrders();
  }, []);

  useEffect(() => {
    getOrders();
  }, [page, rowsPerPage, filterDate, selectedTab]);

  useEffect(() => {
    if (openDetails) {
      const draft = localStorage.getItem("pricePlanDraft");
      if (draft) {
        const parsed = JSON.parse(draft);
        if (parsed.requestId === request?.request_id) {
          setSelectedBundles(parsed.selectedBundles);
          setBundleData(parsed.bundleData);
          if (parsed.expiryDate) {
            setExpiryDate(parsed.expiryDate);
            setDisplayDate(formatToDisplay(parsed.expiryDate));
          }
        }
      }
    }
  }, [openDetails, request]);

  useEffect(() => {
    if (id && orders.length > 0) {
      const targetRow = orders.find((o) => o.id === Number(id));
      if (targetRow) {
        handlOpenDetails(targetRow);
      }
    }
  }, [id, orders]);

  useEffect(() => {
    if (!id) return;

    const fetchAndOpen = async () => {
      try {
        const res = await axios.get(
          `${newBaseUrl}/api/portal/price-plans/requests/${id}`,
          { headers },
        );
        const row = res.data.data; 
        handlOpenDetails(row);
      } catch (err) {
        console.log(err);
      }
    };

    fetchAndOpen();
  }, [id]);

  // *********************** firebase ************************

  const [newRequestIds, setNewRequestIds] = useState(new Set());

  const clearNewRequest = (id) => {
    setNewRequestIds((prev) => {
      const next = new Set(prev);
      next.delete(id);
      return next;
    });
  };

  const toggleReadStatus = async (row) => {
    try {
      await axios.post(
        `${newBaseUrl}/api/portal/price-plans/requests/${row.id}/toggle-read`,
        {},
        { headers },
      );
      setOrders((prev) =>
        prev.map((o) =>
          o.id === row.id ? { ...o, is_read: o.is_read === "1" ? "0" : "1" } : o,
        ),
      );
      if (row.is_read === "0") {
        clearNewRequest(row.id);
      }
    } catch (error) {
      toast.error(error.response?.data?.message || "Something went wrong");
    }
  };

  useEffect(() => {
    if (!token) return;
    const pageOpenTime = Date.now();
    const liveRequestsRef = query(
      ref(database, "price_plan_requests"),
      limitToLast(5),
    );
    const unsubscribe = onChildAdded(liveRequestsRef, (snapshot) => {
      const data = snapshot.val();
      const recordTime = new Date(data.created_at).getTime();
      if (recordTime < pageOpenTime) {
        console.log("⏭️ Old record, skipping:", data);
        return;
      }
      console.log("🆕 New request id:", data.id);
      setTimeout(() => {
        axios
          .get(`${newBaseUrl}/api/portal/price-plans/requests`, {
            headers,
            params: { id: data.id },
          })
          .then((res) => {
            const newRequest = res.data.data.requests?.data?.[0];
            if (!newRequest) return;
          setOrders((prev) => {
            if (prev.find((o) => o.id === newRequest.id)) return prev;
            return [{ ...newRequest, is_read: "0" }, ...prev]; 
          });
            setTotalCount((prev) => prev + 1);
            setNewRequestIds((prev) => new Set([...prev, newRequest.id]));
            getStatuses();
          })
          .catch(console.error);
      }, 8000);
    });
    return () => unsubscribe();
  }, [token]);

  // *********************** firebase ************************

  return (
    <div className="m-4">
      {/* ===================== Drawer ===================== */}
      <Drawer
        anchor="right"
        open={openDetails}
        onClose={() => setOpenDetails(false)}
        PaperProps={{
          sx: { width: 600, padding: 2, backgroundColor: "#fafafa" },
        }}
      >
        {drawerMode === "edit" && (
          <>
            {/* Header */}
            <div className="d-flex justify-content-between align-items-center mb-3">
              <h6 className="fw-bold mb-0">Request #{request?.request_id}</h6>
              <IconButton onClick={() => setOpenDetails(false)}>
                <Cancel />
              </IconButton>
            </div>
            <Divider />
            {/* Client Info */}
            <div className="mt-3 row d-flex justify-content-between align-items-center drawer-info">
              <div className="col-6 gap-2 d-flex flex-column">
                <span>Client Name</span>
                <div className=" d-flex align-items-center">
                  <img
                    src={
                      request?.customer?.profile_photo
                        ? `${newBaseUrl}${request?.customer?.profile_photo}`
                        : client
                    }
                    alt=""
                  />
                  <p className="mx-2">{request?.customer?.name}</p>
                </div>
                <span>Time</span>
                <p>{request?.created_at}</p>
              </div>
              <div className="col-6 gap-2 d-flex flex-column">
                <span>Mobile Number</span>
                <div>
                  <p>{request?.customer?.phone_number}</p>
                </div>
                <span>Maintenance</span>
                <p>{request?.category?.name}</p>
              </div>
            </div>
            {/* Expiry Date */}
            <div className="row mt-2">
              <div className="col-5">
                <DatePickerDMY
                  label="Expiry Date"
                  value={expiryDate}
                  min={new Date().toISOString().split("T")[0]}
                  onChange={(iso) => {
                    setExpiryDate(iso);
                    setDisplayDate(formatToDisplay(iso));
                  }}
                />
              </div>
            </div>
            <Divider className="my-3" />
            {/* Bundles */}
            <div>
              {request?.suggested_templates?.map((bundle) => {
                const isOpen = openBundleId === bundle?.template?.id;
                return (
                  <div key={bundle?.template?.id}>
                    <div className="bundle-card d-flex justify-content-between align-items-center">
                      <div className="d-flex align-items-center">
                        {/* <input type="checkbox" /> */}
                        <input
                          type="checkbox"
                          checked={selectedBundles.includes(bundle.template.id)}
                          onChange={() =>
                            handleToggleBundleSelect(
                              bundle.template.id,
                              bundle.template.name,
                            )
                          }
                        />

                        <img
                          src={`${newBaseUrl}${bundle?.template.profile_image_url}`}
                          alt=""
                        />
                        <span>{bundle?.template?.name}</span>
                      </div>

                      <div
                        style={{ width: "105px", cursor: "pointer" }}
                        className="d-flex justify-content-between align-items-center"
                      >
                        <p className=" fw-semibold mb-0">
                          {getBundleTotal(bundle.template.id)} EGP
                        </p>{" "}
                        <div onClick={() => toggleBundle(bundle?.template?.id)}>
                          {isOpen ? <ChevronUp /> : <ChevronDown />}
                        </div>
                      </div>
                    </div>
                    {/* ===== Bundle Details ===== */}
                    {isOpen && (
                      <div className="bundle-details">
                        {services.map((service, index) => (
                          <div
                            key={index}
                            className="service-row row d-flex justify-content-start align-items-center border-bottom pb-2 mx-1"
                          >
                            <div className="col-4">
                              <span>Type</span>
                              <p className="my-0 pt-2">
                                {service.service?.name}
                              </p>
                            </div>

                            <div className="col-3">
                              <span>Service Price</span>
                              <p className="my-0 pt-2">
                                {formatNumber(service.service?.price)}
                              </p>
                            </div>
                            {service.available_products.length > 0 &&
                              (() => {
                                const selectedProduct =
                                  service.available_products.find(
                                    (p) =>
                                      p.id ==
                                      bundleData[bundle.template.id]
                                        ?.services?.[service.service.id]
                                        ?.productId,
                                  );

                                return (
                                  <div className="col-5 d-flex flex-column position-relative">
                                    <span className="pt-2 pb-1">
                                      Service Product
                                    </span>

                                    {/* Selected */}
                                    <div
                                      className="custom-select"
                                      onClick={() =>
                                        setOpenSelect((prev) =>
                                          prev === service.service.id
                                            ? null
                                            : service.service.id,
                                        )
                                      }
                                    >
                                      <span title={selectedProduct?.name}>
                                        {selectedProduct?.name ||
                                          "Select Product"}
                                      </span>

                                      <span>
                                        {formatNumber(
                                          selectedProduct?.current_price,
                                        ) || ""}
                                      </span>
                                    </div>

                                    {/* Options */}
                                    {openSelect === service.service.id && (
                                      <ul className="custom-options">
                                        {service.available_products.map(
                                          (pro) => (
                                            <li
                                              key={pro.id}
                                              onClick={(e) => {
                                                e.stopPropagation();

                                                handleProductSelect(
                                                  bundle.template.id,
                                                  service.service.id,
                                                  pro.id,
                                                  service.available_products,
                                                );

                                                setOpenSelect(null);
                                              }}
                                            >
                                              <span title={pro.name}>
                                                {pro.name}
                                              </span>
                                              <span>
                                                {formatNumber(
                                                  pro.current_price,
                                                )}
                                              </span>
                                            </li>
                                          ),
                                        )}
                                      </ul>
                                    )}
                                  </div>
                                );
                              })()}
                          </div>
                        ))}
                      </div>
                    )}
                  </div>
                );
              })}
            </div>
            <div className="mt-3 row">
              <div className="col-6">
                <button
                  className="btn btn-outline-secondary w-100"
                  onClick={handleSaveDraft}
                >
                  Save as Draft
                </button>
              </div>
              <div className="col-6">
                <button
                  className="btn btn-dark w-100"
                  disabled={selectedBundles.length === 0}
                  onClick={handleSendBundles}
                >
                  Send {selectedBundles.length} Bundle
                </button>
              </div>
            </div>
          </>
        )}
        {drawerMode === "profile" && (
          <>
            {loadingAnalysis ? (
              <div className="text-center mt-5">Loading...</div>
            ) : (
              <RequestProfile
                setOpenDetails={setOpenDetails}
                analysis={analysisData}
              />
            )}
          </>
        )}
      </Drawer>
      {/* ===================== TABLE & REST OF UI ===================== */}
      {/* orders header */}
      <div className="mb-3">
        <h5 className="fw-semibold mb-0">User Requests - Maintenance</h5>
      </div>
      {/* search section */}
      <div className="d-flex align-items-center" style={{ width: "70%" }}>
        {/* search input */}
        <div className="w-50 mt-1">
          <FormControl fullWidth variant="outlined" size="small">
            <InputLabel htmlFor="search-orders">
              Search by request ID or customer name...
            </InputLabel>
            <OutlinedInput
              id="search-orders"
              type="text"
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              onKeyUp={getOrders}
              label="Search by order ID or customer name..."
              endAdornment={
                <InputAdornment position="end">
                  <IconButton onClick={getOrders}>
                    <Search />
                  </IconButton>
                </InputAdornment>
              }
            />
          </FormControl>
        </div>
        {/* date input */}
        <div className="w-25 mb-2 mx-2">
          <DatePickerDMY
            value={filterDate}
            onChange={(iso) => {
              setFilterDate(iso);
              setPage(0);
            }}
          />
        </div>
      </div>
      {/* tabs section */}
      <div
        className="tabs-section bg-light rounded-3 d-flex align-items-center mb-3"
        style={{
          width: "fit-content",
          maxWidth: "100%",
          overflowX: "auto",
          whiteSpace: "nowrap",
          WebkitOverflowScrolling: "touch",
          height: "50px",
        }}
      >
        <Tabs
          value={selectedTab}
          onChange={(_, newValue) => setSelectedTab(newValue)}
          variant="scrollable"
          scrollButtons="auto"
          allowScrollButtonsMobile
          aria-label="dynamic tabs"
          TabIndicatorProps={{ style: { display: "none" } }}
          sx={{
            "& .MuiTabs-flexContainer": {
              display: "inline-flex",
              alignItems: "center",
              justifyContent: "center",
              gap: "12px",
              width: "fit-content",
            },
            "& .MuiTab-root": {
              textTransform: "none",
              borderRadius: "10px",
              minHeight: "40px",
              color: "#000",
              fontWeight: 500,
              transition: "all 0.3s ease",
            },
            "& .MuiTab-root.Mui-selected": {
              backgroundColor: "#000",
              color: "#fff",
            },
          }}
        >
          <Tab
            key="all"
            value="all"
            label={
              <span className="tab-label">
                All <span className="circle">{total}</span>
              </span>
            }
          />
          {statuses.map((st) => (
            <Tab
              key={st.status_key}
              value={st.status_key}
              label={
                <span className="tab-label">
                  {st.status_name}
                  <span
                    className="circle"
                    style={{ backgroundColor: st.color }}
                  >
                    {st.count}
                  </span>
                </span>
              }
            />
          ))}
        </Tabs>
      </div>
      {/* table data */}
      <>
        <TableContainer
          component={Paper}
          sx={{
            mt: 3,
            borderRadius: "12px",
            overflowX: "auto",
            overflowY: "hidden",
            boxShadow: "0 4px 12px rgba(0,0,0,0.05)",
            border: "1px solid #e0e0e0",
            transition: "all 0.3s ease",
          }}
        >
          <Table
            size="small"
            sx={{
              minWidth: "1200px",
              borderCollapse: "separate",
              borderSpacing: "0",
              "& td, & th": {
                textAlign: "center",
                verticalAlign: "middle",
              },
              "& thead th": {
                backgroundColor: "#f4f6f8",
                fontWeight: 600,
                color: "#333",
                textTransform: "capitalize",
                fontSize: "14px",
                borderBottom: "2px solid #ddd",
              },
              "& tbody tr": {
                transition: "background-color 0.2s ease",
              },
              "& tbody tr:hover": {
                backgroundColor: "#fafafa",
              },
              "& td": {
                fontSize: "14px",
                color: "#333",
                borderBottom: "1px solid #eee",
                p: "12px",
              },
            }}
          >
            <TableHead>
              <TableRow>
                <TableCell padding="checkbox">
                  <Checkbox
                    color="primary"
                    indeterminate={
                      selectedRows.length > 0 &&
                      selectedRows.length < orders.length
                    }
                    checked={
                      orders.length > 0 && selectedRows.length === orders.length
                    }
                    onChange={handleSelectAll}
                    sx={{
                      padding: "6px",
                      color: "rgba(0,0,0,0.25)",
                      "&.Mui-checked, &.MuiCheckbox-indeterminate": {
                        color: "#3EADA3",
                      },
                      "& .MuiSvgIcon-root": {
                        fill: "transparent",
                        stroke: "rgba(0,0,0,0.25)",
                        fontSize: "24px",
                        strokeWidth: 1,
                      },
                      "&.Mui-checked .MuiSvgIcon-root, &.MuiCheckbox-indeterminate .MuiSvgIcon-root":
                        {
                          stroke: "#3EADA3",
                        },
                    }}
                  />
                </TableCell>
                <TableCell>Request ID</TableCell>
                <TableCell>Client Name</TableCell>
                <TableCell>Car Model</TableCell>
                <TableCell>Mobile Number</TableCell>
                <TableCell>Maintenance</TableCell>
                <TableCell>Time</TableCell>
                <TableCell>Status</TableCell>
                <TableCell>Actions</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {orders && orders.length > 0 ? (
                orders?.map((row) => {
                  const isSelected = selectedRows.includes(row.id);
                  return (
                    <React.Fragment key={row.id}>
                      <TableRow
                        hover
                        sx={{
                          animation: newRequestIds.has(row.id)
                            ? "slideInRow 0.4s ease"
                            : "none",
                          backgroundColor: isSelected
                            ? "#494646 !important"
                            : row.is_read === "0" || newRequestIds.has(row.id)
                              ? "#e8f5e9 !important"
                              : "inherit",
                          "&:hover": {
                            backgroundColor: isSelected
                              ? "#413e3e !important"
                              : row.is_read === "0" || newRequestIds.has(row.id)
                                ? "#d0f0e8 !important"
                                : "#fafafa",
                          },
                          "& td": {
                            color: isSelected ? "#ffffff" : "#333",
                            fontWeight: isSelected ? 600 : 400,
                            transition: "all 0.2s ease",
                          },
                        }}
                      >
                        <TableCell padding="checkbox">
                          <Checkbox
                            color="primary"
                            checked={isSelected}
                            onChange={() => handleSelectRow(row.id)}
                            sx={{
                              padding: "6px",
                              color: "rgba(0,0,0,0.25)",
                              "&.Mui-checked": {
                                color: "#3EADA3",
                              },
                              "& .MuiSvgIcon-root": {
                                fontSize: "24px",
                                fill: "white",
                                stroke: isSelected
                                  ? "#3EADA3"
                                  : "rgba(0,0,0,0.25)",
                                strokeWidth: 1,
                              },
                            }}
                          />
                        </TableCell>
                        <TableCell>
                          <div className="d-flex flex-column align-items-center justify-content-center">
                            {row.id}
                            {(row.is_read === "0" ||
                              newRequestIds.has(row.id)) && (
                              <span className="new-badge">NEW</span>
                            )}
                          </div>
                        </TableCell>{" "}
                        <TableCell sx={{ fontWeight: 500 }}>
                          {row.user?.name || "-"}
                        </TableCell>
                        <TableCell>{row.car?.model || "-"}</TableCell>
                        <TableCell>{row.user?.phone || "-"}</TableCell>
                        <TableCell>{row.category?.name || "-"}</TableCell>
                        <TableCell>{row.created_at || "-"}</TableCell>
                        <TableCell>
                          <div className="text-center w-75 mx-auto">
                            <div className="d-flex justify-content-start align-items-center">
                              <img
                                className="me-2"
                                src={`${row?.status?.image_url}`}
                                alt=""
                              />
                              {row.status?.key || "-"}
                            </div>
                          </div>
                        </TableCell>
                        <TableCell>
                          <div className="d-flex justify-content-center align-items-center gap-1 mx-auto">
                            <IconButton
                              size="small"
                              onClick={async () => {
                                if (row.is_read === "0") {
                                  await toggleReadStatus(row);
                                }
                                handlOpenDetails(row);
                              }}
                            >
                              <ChevronRight />
                            </IconButton>

                            {row.is_read === "1" && (
                              <IconButton
                                size="small"
                                onClick={async (e) => {
                                  e.stopPropagation();
                                  await toggleReadStatus(row);
                                }}
                              >
                                <EyeOff size={18} />
                              </IconButton>
                            )}
                          </div>
                        </TableCell>
                      </TableRow>
                    </React.Fragment>
                  );
                })
              ) : (
                <TableRow>
                  <TableCell colSpan={12} sx={{ height: "300px", p: 0 }}>
                    <Box
                      sx={{
                        height: "100%",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        textAlign: "center",
                      }}
                    >
                      <NotFound
                        paragraphText={
                          "No orders yet. All your orders will appear here once you get started."
                        }
                      />
                    </Box>
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>
        <TablePagination
          component="div"
          count={totalCount}
          page={page}
          onPageChange={handleChangePage}
          rowsPerPage={rowsPerPage}
          onRowsPerPageChange={(event) => {
            setRowsPerPage(parseInt(event.target.value, 10));
            setPage(0);
          }}
          rowsPerPageOptions={[5, 10, 20]}
          sx={{
            ".MuiTablePagination-toolbar": { justifyContent: "center" },
          }}
        />
      </>
    </div>
  );
}
